// Dependencies
import React, { FunctionComponent, useEffect } from 'react'

// Components
import { Footer as FooterComponent } from 'component-library/footer'

// Styles
import * as S from './styles'

// Assets
import logoColoredSvg from '../../assets/logo_proenem_2023.svg'
import youtube from '../../assets/youtube.svg'
import spotify from '../../assets/spotify.svg'
import twitter from '../../assets/twitter.svg'
import tiktok from '../../assets/tiktok.svg'
import instagram from '../../assets/instagram.svg'
import facebook from '../../assets/facebook.svg'

export const Footer: FunctionComponent = () => {
  const renderComplainHere = () => {
    const script = document.createElement('script')
    script.setAttribute('type', 'text/javascript')
    script.setAttribute('id', 'ra-embed-reputation')
    script.setAttribute(
      'src',
      'https://s3.amazonaws.com/raichu-beta/selos/bundle.js'
    )
    script.setAttribute('data-id', 'MTAyMzI5OnByb2VuZW0=')
    script.setAttribute('data-target', 'reputation-ra')
    script.setAttribute('data-model', '2')
    script.setAttribute('defer', '')

    const ra = document.getElementById('reputation-ra')
    ra?.appendChild(script)
  }

  const scrollToTop = () => {
    window.scroll({ top: 0 })
  }

  useEffect(() => {
    renderComplainHere()

    const el = document.querySelector('a[data-key="/"]')

    el?.addEventListener('click', (ev) => {
      ev.preventDefault()
      scrollToTop()
    })
  }, [])

  const footer = {
    logoSrc: logoColoredSvg,
    socialNetworks: [
      {
        iconSrc: youtube,
        href: 'https://www.youtube.com/@ProENEMOficial'
      },
      {
        iconSrc: spotify,
        href: 'https://open.spotify.com/show/6prfXbOrIk2UtLv6KPclUV'
      },
      {
        iconSrc: tiktok,
        href: 'https://www.tiktok.com/@proenemoficial?lang=pt-BR'
      },
      {
        iconSrc: facebook,
        href: 'https://www.facebook.com/proenem/'
      },
      {
        iconSrc: instagram,
        href: 'https://www.instagram.com/proenem/?hl=pt-br'
      },
      {
        iconSrc: twitter,
        href: 'https://x.com/ProEnemOficial'
      }
    ],
    ourClassesLinks: [
      {
        name: 'ENEMPRO 2026',
        link: 'https://proenem.com.br/#turmas'
      },
      {
        name: 'ENEMVIP 2026',
        link: 'https://proenem.com.br/#turmas'
      },
      {
        name: 'MEVIP 2026',
        link: 'https://proenem.com.br/#turmas'
      }
    ],
    bookletsLinks: [
    ],
    supportLinks: [
      {
        name: 'Central de atendimento',
        link: 'https://atendimento.proenem.com.br/'
      },
      {
        name: 'Termos de uso',
        link: 'https://atendimento.proenem.com.br/termos-de-uso/'
      },
      {
        name: 'Cancelamento',
        link: 'https://atendimento.proenem.com.br/cancelamento/'
      }
    ]
  }

  return (
    <S.WrapperFooter>
      <FooterComponent
        logoSrc={footer.logoSrc}
        socialNetworks={footer.socialNetworks}
        bookletsLinks={footer.bookletsLinks}
        ourClassesLinks={footer.ourClassesLinks}
        supportLinks={footer.supportLinks}
      />
    </S.WrapperFooter>
  )
}
